import React, {
  useContext,
  useEffect,
  useState,
  useRef,
  useCallback,
} from "react";
import Context from "../../context/Context";
import styles from "../ShowCase/showcase.module.css";
import Play from "../../../src/assests/play.svg";
import swipe from "../../assests/swipe-left.svg";
import { Link, useNavigate } from "react-router-dom";
import * as _ from "lodash";
import ReactPlayer from "react-player";
import PopupShowcase from "../PopupShowcase/PopupShowcase";
import "../Footer/Footer.css";
import useShowCaseGallery from "../../hooks/useShowCaseGalleryScroll";
import Lottie from "react-lottie-player";
import loadingAnimation from "../../assests/loading.json";
import Footer from "../Footer/Footer";
import Popup from "../Popup/Popup";
import "./Showcase.css";
import ServiceForm from "./ServiceForm";
import axios from "axios";
import Banner from "../Banner";
function Showcase() {
  const [service, setService] = useState();
  const [serviceForm, setServiceForm] = useState(false);
  const [clickedImg, setClickedImg] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const [showGallery, setShowGallery] = useState(true);
  const [showWinners, setShowWinners] = useState(false);

  const [showcaseContents, setShowcaseContents] = useState([]);
  const [dataloading, setDataLoading] = useState(false);
  const { details } = useContext(Context);
  const [error, setError] = useState(false);

  let organizerId = details?.orgId;
  let campaignId = details?._id;

  // const { dataloading, error, showcaseContents, hasMore } = useShowCaseGallery(
  //   pageNumber,
  //   campaignId,
  //   organizerId
  // );
  const element = document.querySelector(".slider1");

  if (element) {
    element.addEventListener("wheel", (event) => {
      event.preventDefault();
      element.scrollLeft += event.deltaY;
    });
  }
  useEffect(() => {
    loadShowcaseDetails();
  }, [organizerId, campaignId]);
  const loadShowcaseDetails = async () => {
    setDataLoading(true);
    try {
      const data = await axios.get(
        `${process.env.REACT_APP_HOME_SHOWCASE_URL}/${organizerId}/${campaignId}/showcase.json`
      );
      setShowcaseContents(data?.data);
      setDataLoading(false);
    } catch (error) {
      setDataLoading(false);
      setError(true);
      console.log(error.message);
      //navigate("/error")
    }
  };
  const observer = useRef();
  // console.log("showcase", showcaseContents);
  // const lastElementRef = useCallback(
  //   (node) => {
  //     if (dataloading) return;
  //     if (observer.current) observer.current.disconnect();
  //     observer.current = new IntersectionObserver((entries) => {
  //       if (entries[0].isIntersecting && hasMore) {
  //         setPageNumber((prevPageNumber) => prevPageNumber + 1);
  //       }
  //     });
  //     if (node) observer.current.observe(node);
  //   },
  //   [dataloading, hasMore]
  // );

  const handleClick = (item, index) => {
    setCurrentIndex(index);
    setClickedImg(item);
  };
  const handelRotationRight = () => {
    const totalLength = showcaseContents?.length;

    // if (currentIndex + 3 >= totalLength) {
    //   setPageNumber(pageNumber + 1);
    // }
    let newIndex = currentIndex + 1;
    if (newIndex === totalLength) {
      newIndex = 0;
    }
    const newUrl = showcaseContents?.filter((item) => {
      return showcaseContents?.indexOf(item) === newIndex;
    });
    const newItem = newUrl[0];
    setClickedImg(newItem);
    setCurrentIndex(newIndex);
  };

  const handelRotationLeft = () => {
    // console.log(showcaseContents);
    const totalLength = showcaseContents?.length;
    if (currentIndex === 0) {
      setCurrentIndex(totalLength - 1);
      const newUrl = showcaseContents && showcaseContents[totalLength - 1];
      setClickedImg(newUrl);
      return;
    }
    const newIndex = currentIndex - 1;
    const newUrl = showcaseContents?.filter((item) => {
      return showcaseContents?.indexOf(item) === newIndex;
    });
    const newItem = newUrl[0];
    setClickedImg(newItem);
    setCurrentIndex(newIndex);
  };
  // console.log(showcaseContents);
  return (
    <>
      <div className="widthController ">
        {!dataloading && showcaseContents.length == 0 ? (
          <div className="w-[100%] h-[300px] flex flex-col items-center justify-center text-[#787878]">
            <span className="text-[17px] font-semibold">Showcase Empty</span>
            <span className="text-[14px] font-medium mt-[10px] text-center">
              All the showcased entries will be
              <br /> displayed here.
            </span>
          </div>
        ) : (
          <div className="widthController pb-[5px] bg-black">
            {serviceForm && (
              <ServiceForm
                service={service}
                setServiceForm={setServiceForm}
                orgDomain={showcaseContents?.orgDomain}
              />
            )}
            <div className={styles.ShowCaseCovers}></div>
            {/* <Banner /> */}
            <div className="pl-[16px] mb-[100px]">
              {showcaseContents &&
                showcaseContents?.map((carousel) => {
                  return (
                    <>
                      <p className="text-[24px]  text-white font-semibold mt-[20px]">
                        {carousel.heading}
                      </p>
                      <div className="h-[100%] flex box w-[100%] gap-[20px] overflow-x-auto md:pt-[10px] slider1 box">
                        {carousel &&
                          carousel.items &&
                          carousel.items.map((add) => {
                            return (
                              <>
                                <div
                                  className="w-[200px] flex flex-col justify-between bg-white"
                                  // style={{backgroundColor: add?.bgColor}}
                                >
                                  <div className=" ">
                                    {add.type == "image" && (
                                      <img
                                        src={add.imageUrl}
                                        alt=""
                                        className="min-w-[200px] h-[200px] object-cover"
                                      />
                                    )}
                                    {add.type == "video" && (
                                      <div className="min-w-[200px] h-[200px] md:h-[200px] ">
                                        <ReactPlayer
                                          config={{
                                            file: {
                                              attributes: {
                                                controlsList: "nodownload",
                                              },
                                            },
                                            youtube: {
                                              playerVars: { disablekb: 1 },
                                            },
                                          }}
                                          // playing={true}
                                          controls={true}
                                          width="100%"
                                          height="100%"
                                          url={add?.videoUrl}
                                          className="object-contain height-[100%]"
                                        />
                                      </div>
                                    )}
                                    {add?.description && (
                                      <p className="text-[12px] text-black mt-[8px] px-[15px]  ">
                                        {add.description}
                                      </p>
                                    )}
                                  </div>
                                  {add?.shopbuttton && (
                                    <div
                                      className="w-[130px] h-[40px] bg-[#5073EF] text-[14px] text-white rounded-[50px] flex items-center justify-center mt-[10px] hover:cursor-pointer mx-[15px]"
                                      onClick={() => {
                                        if (add.goto === "form") {
                                          setService(add);
                                          setServiceForm(true);
                                        } else {
                                          window.open(add.goto, "_blank");
                                        }
                                      }}
                                    >
                                      {add.shopbuttton}
                                    </div>
                                  )}
                                </div>
                              </>
                            );
                          })}
                      </div>
                      {carousel.items.length > 2 && (
                        <div className="w-[100%] h-[40px] flex items-center justify-end mt-[10px] mr-[16px] pr-[16px] swipebg">
                          <p className="text-[14px] text-white mr-[10px] italic">
                            Swipe left to view more
                          </p>
                          <div className="h-[24px] w-[24px] bg-white rounded-full">
                            <img
                              src={swipe}
                              alt=""
                              className="h-[100%] w-[100%]"
                            />
                          </div>
                        </div>
                      )}
                    </>
                  );
                })}
            </div>
            <div>
              {dataloading && (
                <div className="w-[100vw] max-w-[425px] flex align-center justify-center">
                  <Lottie
                    loop
                    animationData={loadingAnimation}
                    play
                    style={{ width: 173, height: 173 }}
                  />
                </div>
              )}
            </div>
          </div>
        )}
        <div className={styles.bottmenu}>
          <Footer elementId="showcase" />
        </div>
      </div>
    </>
  );
}

export default Showcase;
